<template lang="pug">
  panner
    table.product-owner-summary-table
      thead
        tr
          th Region
          th Price
          th Case price
          th Msrp
          th Margin
          th Availability
          th(v-if="isMOQSku") MOQ
      tbody
        template(v-for="i,k in reGroup")
          tr
            td.region
              region-stamp(:value="i.region_id")
            td.price
              span.current(:class="{promoted: !!promotion}") {{ i.unit_price_str }}
              price-change-stamp(:variant="i")
              span.old(v-if="promotions.length") {{ variant.case_price_cents / variant.case_units | cents }}
              div.per per unit
            td.case-price
              span.current(:class="{promoted: !!promotion}") {{ i.case_price_cents | promotion-price(promotion) }}
              span.old(v-if="promotions.length") {{ i.case_price_cents | cents }}
              div.per {{ `${i.case_units} ${i.case_units > 1 ? 'units' : 'unit'} per case` }}
            td.msrp {{ i.msrp_str }}
            td.margin {{ i.margin_str }}
            td.pd-availability
              span(:class="i.availability.replace('_', '-')") {{ i.availability | productVariantAvailability }}
            td.moq(v-if="isMOQSku") {{ i._moq }}
</template>
<script>
import { LIMIT_TYPES } from '~/settings'
import RegionStamp from '~/components/stamps/RegionStamp'
import Panner from '~/components/Panner'
import PriceChangeStamp from '~/components/stamps/PriceChangeStamp'

export default {
  name: 'ProductOwnerSummary',

  components: {
    Panner,
    RegionStamp,
    PriceChangeStamp
  },

  props: {
    variant: {
      type: Object,
      required: true
    },

    product: {
      type: Object,
      required: true
    }
  },

  computed: {
    isMOQSku () {
      return this.variant && this.variant.limit_type === LIMIT_TYPES.MOQ
    },

    isStoreSpecific () {
      return this.variant && Array.isArray(this.variant.stores_variants_regions) && this.variant.stores_variants_regions.length
    },

    promotions () {
      if (!this.variant) return []
      return this.variant.promotions || []
    },

    promotion () {
      return this.promotions.length ? this.promotions[0] || null : null
    },

    reGroup () {
      if (!this.variant) return []
      return this.variant.variants_regions
        .map(i => {
          const moq = this.product.products_region_moqs.find(moq => moq.region_id === i.region_id)
          return {
            ...i,
            _moq: moq ? moq.moq : 0
          }
        })
    }
  },

  methods: {
    findMoqByRegion (region) {
      const moq = this.product.products_region_moqs.find(i => i.region_id === +region)
      return moq ? moq.moq : 0
    }
  }
}
</script>
<style lang="scss" src="~/assets/product.scss" scoped />
